<template>
  <!--==================
    component used in operator review (edit)
    ===============-->
  <modal name="review-edit-modal" size="middle" @onShow="modalShow" @onHide="modalHide">
    <div class="card-body p-0">
      <h3 class="card-title">Edit Review</h3>

      <form class="mt-4" @submit.prevent="updateReview">
        <div class="form-row align-items-center col-md-10 mb-3">
          <span class="col-2">Full Name</span>
          <div class="form-group col-4 p-0 mt-0">
            <input
              @input="$v.form.fullName.$touch()"
              class="form-control form-control-sm"
              type="text"
              v-model="form.fullName"
            />
            <span class="text-danger" v-if="$v.form.fullName.$dirty && !$v.form.fullName.required">
              &nbsp; This field is required
            </span>
          </div>
        </div>
        <div class="form-row align-items-center col-md-10 mb-3">
          <span class="col-2">Email</span>
          <div class="form-group col-4 p-0 mt-0">
            <input
              @input="$v.form.email.$touch()"
              class="form-control form-control-sm"
              type="email"
              v-model="form.email"
            />
            <span class="text-danger" v-if="$v.form.email.$dirty && !$v.form.email.required">
              &nbsp; This field is required
            </span>
          </div>
        </div>
        <div class="form-row align-items-center col-md-10 mb-3">
          <span class="col-2">Title</span>
          <div class="form-group col-4 p-0 mt-0">
            <input
              @input="$v.form.title.$touch()"
              class="form-control form-control-sm"
              type="text"
              v-model="form.title"
            />
            <span class="text-danger" v-if="$v.form.title.$dirty && !$v.form.title.required">
              &nbsp; This field is required
            </span>
          </div>
        </div>
        <div class="form-row align-items-center col-md-10 mb-3">
          <span class="col-2">Rate</span>
          <div class="form-group col-4 p-0 mt-0">
            <input
              @input="$v.form.rate.$touch()"
              class="form-control form-control-sm"
              type="number"
              v-model="form.rate"
            />
            <span class="text-danger" v-if="$v.form.rate.$dirty && !$v.form.rate.required">
              &nbsp; This field is required
            </span>
          </div>
        </div>
        <div class="form-row align-items-center col-md-10 mb-3">
          <span class="col-2">Package ID</span>
          <div class="form-group col-4 p-0 mt-0">
            <input class="form-control form-control-sm" type="number" v-model="form.package" />
          </div>
        </div>
        <div class="form-row align-items-center col-md-10 mb-3">
          <span class="col-2">Operator ID</span>
          <div class="form-group col-4 p-0 mt-0">
            <input
              @input="$v.form.user.$touch()"
              class="form-control form-control-sm"
              type="number"
              v-model="form.user"
            />
            <span class="text-danger" v-if="$v.form.user.$dirty && !$v.form.user.required">
              &nbsp; This field is required
            </span>
          </div>
        </div>
        <div class="form-row align-items-center col-md-10 mb-3">
          <span class="col-2">Date</span>
          <div class="form-group col-4 p-0 mt-0">
            <input
              @input="$v.form.date.$touch()"
              class="form-control form-control-sm"
              type="date"
              v-model="form.date"
            />
            <span class="text-danger" v-if="$v.form.date.$dirty && !$v.form.date.required">
              &nbsp; This field is required
            </span>
          </div>
        </div>
        <div class="form-row align-items-center col-md-10 mb-3">
          <span class="col-2">Time</span>
          <div class="form-group col-4 p-0 mt-0">
            <input
              @input="$v.form.time.$touch()"
              class="form-control form-control-sm"
              type="time"
              step="1"
              v-model="form.time"
            />
            <span class="text-danger" v-if="$v.form.time.$dirty && !$v.form.time.required">
              &nbsp; This field is required
            </span>
          </div>
        </div>
        <div class="form-row align-items-center col-md-10 mb-3">
          <span class="col-2">Description</span>
          <div class="form-group col-10 p-0 mt-0">
            <textarea
              style="resize: none"
              class="form-control"
              rows="7"
              @input="$v.form.description.$touch()"
              v-model="form.description"
            ></textarea>
            <span class="text-danger" v-if="$v.form.description.$dirty && !$v.form.description.required">
              &nbsp; This field is required
            </span>
          </div>
        </div>

        <div class="form-group text-center my-5">
          <button class="btn btn-sm btn-success col-md-4" type="submit" :disabled="$v.form.$invalid">
            <span>UPDATE</span>
          </button>
        </div>
      </form>
    </div>
  </modal>
</template>

<style>
.modal__content {
  overflow: auto;
}
</style>

<script>
import $ from "jquery";
import { mapActions } from "vuex";
import { required } from "vuelidate/lib/validators";
const dateFormat = require("dateformat");

export default {
  name: "ReviewEditModal",

  data() {
    return {
      reviewId: null,
      operatorId: null,
      form: {
        fullName: null,
        email: null,
        title: null,
        rate: null,
        package: null,
        user: null,
        description: "",
        date: null,
        time: null,
      },
    };
  },

  validations() {
    return {
      form: {
        fullName: { required },
        email: { required },
        title: { required },
        rate: { required },
        user: { required },
        description: { required },
        date: { required },
        time: { required },
      },
    };
  },

  methods: {
    ...mapActions(["operatorReviewUpdate", "fetchOperatorReviews", "showSpinnerLoading", "hideSpinnerLoading"]),

    modalShow() {
      const payload = this.$modal.$payload;
      this.reviewId = this.$modal.$payload.id;
      this.operatorId = this.$modal.$payload.user;

      this.form.fullName = payload.fullName;
      this.form.email = payload.email;
      this.form.title = payload.title;
      this.form.rate = payload.rate;
      this.form.package = payload.package;
      this.form.user = payload.user;
      this.form.description = payload.description;
      this.form.date = dateFormat(payload.createdAt, "yyyy-mm-dd");
      this.form.time = dateFormat(payload.createdAt, "HH:MM:ss");
    },

    modalHide() {
      this.$v.$reset();
    },

    async updateReview() {
      this.$modal.hide("review-edit-modal");
      this.showSpinnerLoading();

      const submitData = {};
      submitData["fullName"] = this.form.fullName;
      submitData["email"] = this.form.email;
      submitData["title"] = this.form.title;
      submitData["rate"] = parseInt(this.form.rate);
      submitData["package"] = isNaN(parseInt(this.form.package)) ? null : parseInt(this.form.package);
      submitData["user"] = parseInt(this.form.user);
      submitData["description"] = this.form.description;
      submitData["createdAt"] = `${this.form.date} ${this.form.time}`;
      // console.log(submitData);

      const data = {
        id: this.reviewId,
        detail: submitData,
      };

      await this.operatorReviewUpdate(data)
        .then(async (res) => {
          await this.fetchOperatorReviews(this.operatorId);
          this.hideSpinnerLoading();
          $.alert("review updated successfull");
        })
        .catch(() => {
          this.hideSpinnerLoading();
          $.alert("submision failed!");
        });
    },
  },
};
</script>
